import { eventCreditCardTypes } from 'data/mock-data';

const mock = () => ({
  data: {
    paymentTypes: eventCreditCardTypes,
  },
});

export default mock;
